import { Route, Routes } from 'react-router-dom';
import PolicyConsolidated from '../../pages/Insurance/forms/PolicyConsolidated';
import ClaimConsolidated from '../../pages/Insurance/forms/ClaimConsolidated';
import checkPermissions from '../../HOCs/CheckPermissions';

const InsuranceFormRoutes = () => {
  const PolicyConsolidatedProtected = checkPermissions({
    sectionsToAccess: ['policy'],
    Children: PolicyConsolidated,
    blockAdminType: true,
  });

  const ClaimsConsolidatedProtected = checkPermissions({
    sectionsToAccess: ['claim'],
    Children: ClaimConsolidated,
    blockAdminType: true,
  });

  return (
    <Routes>
      <Route
        path="/policy/consolidated_report"
        element={<PolicyConsolidatedProtected />}
      />
      <Route
        path="/claim/consolidated_report"
        element={<ClaimsConsolidatedProtected />}
      />
    </Routes>
  );
};

export default InsuranceFormRoutes;
